var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoV5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:red;}\n\t.st1{fill:white;}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M44,0C19.7,0,0,19.7,0,44s19.7,44,44,44s44-19.7,44-44S68.3,0,44,0z",
    fill: "red"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,18.7c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0H40c0.2,0,0.4,0.2,0.4,0.4V41c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0   h-2.7c-0.3,0-0.6-0.1-0.7-0.4L23.7,24.6V41c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0h-2.8c-0.2,0-0.4-0.2-0.4-0.4V18.7   c0-0.2,0.2-0.4,0.4-0.4h2.7c0.3,0,0.6,0.2,0.8,0.4l12.9,16.5V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,41.8c-6.6,0-11.9-5.3-11.9-11.9S50.1,18,56.6,18l0,0c6.6,0,11.9,5.3,11.9,11.9S63.2,41.8,56.6,41.8z    M56.6,21.5c-4.5,0-8.2,3.6-8.2,8.2c0,0.1,0,0.1,0,0.2c-0.1,4.5,3.5,8.3,8.1,8.3s8.3-3.5,8.3-8.1c0-0.1,0-0.2,0-0.3   c0.1-4.5-3.5-8.3-8-8.4C56.8,21.5,56.7,21.5,56.6,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,71.1c-0.1,0.3-0.4,0.5-0.7,0.4h-3.1c-0.3,0-0.6-0.2-0.6-0.4l-8.7-22.2c-0.1-0.3-0.1-0.6,0.3-0.6h3.1   c0.3,0,0.6,0.2,0.7,0.5l6.7,18h0.1l6.8-18c0.1-0.3,0.4-0.5,0.7-0.5h3.2c0.3,0,0.4,0.2,0.3,0.6L36.3,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.4,48.7c0-0.2,0.2-0.4,0.4-0.4h12c0.2,0,0.4,0.2,0.4,0.4v2.4c0,0.2-0.2,0.4-0.4,0.4h-9.2l-0.5,5.9   c0.5-0.4,1.1-0.7,1.7-0.8c0.7-0.3,1.4-0.4,2.1-0.4c2.1-0.1,4.2,0.7,5.6,2.3c1.2,1.5,1.9,3.4,1.8,5.4c0,2-0.7,3.9-2,5.4   c-1.7,1.6-4,2.5-6.3,2.4c-2.4,0.1-4.7-0.6-6.6-2c-0.2-0.1-0.3-0.3-0.2-0.6c0,0,0,0,0-0.1l1-2.1c0.1-0.2,0.3-0.3,0.4-0.2   c0,0,0.1,0,0.1,0.1c1.4,1.3,3.3,2,5.3,1.9c1.3,0,2.5-0.5,3.4-1.4c0.8-0.9,1.3-2.1,1.3-3.4c0.1-1.2-0.4-2.5-1.2-3.4   c-0.8-0.8-1.9-1.3-3.1-1.3c-0.9,0-1.9,0.2-2.7,0.7c-0.6,0.4-1.1,0.9-1.5,1.4c-0.1,0.2-0.3,0.3-0.6,0.2L48,61.3   c-0.4-0.1-0.4-0.2-0.4-0.6L48.4,48.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoV5);
export default __webpack_public_path__ + "static/media/no-V5.c5d39648098f2c92b8fd6dac3f89f579.svg";
export { ForwardRef as ReactComponent };